var render = function render(){var _vm=this,_c=_vm._self._c;return _c('modal',{attrs:{"title":_vm.title,"first-button-text":_vm.firstButtonText,"is-loading":_vm.isLoading,"first-button-action":_vm.firstButtonAction,"dark-theme":_vm.darkTheme},on:{"close":_vm.closeModal}},[(_vm.description)?_c('div',[_vm._v(" "+_vm._s(_vm.description)+" ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }